import React from 'react';
import { Heading, URLLink, Source, TestingControl } from './index';
import { Google } from '../../../../../Components/DPP/Controls/Google';
import { Html } from '../../../../../Components/DPP/Controls/Html';
import { Spacer } from '../../../../../Components/DPP/Controls/Spacer';
import { RightsAccess } from '../../../../../Components/helper';
import { CareUserLabelInstruction } from '../../../../../Components/DPP/Controls/CareUserLabelInstruction';

export const CustomSectionTemplate = React.memo((props) => {
  const { TestingRight } = RightsAccess();

  const { dataIndex, dppEle, onClick, fromProduct, expColl } = props;
  const mainFunction = () => {
    switch (props?.keys) {
      case 'heading':
        return <Heading {...props} {...dppEle} />;
      case 'url_link':
        return <URLLink {...props} {...dppEle} />;
      case 'source':
        return <Source {...props} {...dppEle} />;
      case 'testing_control':
        return TestingRight ? <TestingControl {...props} {...dppEle} /> : null;
      case 'google':
        return <Google DPPstate={expColl} {...props} {...dppEle} />;
      case 'html':
        return <Html {...props} {...dppEle} />;
      case 'spacer':
        return <Spacer {...props} {...dppEle} onClick={onClick} fromProduct={fromProduct} />;
      case 'care_user_instruction':
        return <CareUserLabelInstruction {...props} {...dppEle} onClick={onClick} sectionId="care-user-instructions-id" />;
      default:
        return null;
    }
  };
  return <div key={dataIndex}>{mainFunction()}</div>;
});

export default CustomSectionTemplate;
